export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/iRdGJt5QPGeehk1vYL3Tiv/Mockup_HIR.png'
